import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import './GoogleSignIn.css';

function GoogleSignIn() {
  const { isAuthenticated, user, login, logout } = useContext(AuthContext);

  return (
    <div className="google-auth-container">
      {isAuthenticated && user ? (
        <div className="user-profile">
          {user.photo && (
            <img 
              src={user.photo} 
              alt={user.displayName || 'User'} 
              className="user-photo" 
            />
          )}
          <span className="user-name">{user.displayName || user.email || 'User'}</span>
          <button onClick={logout} className="logout-button">
            Logout
          </button>
        </div>
      ) : (
        <button onClick={login} className="google-signin-button">
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" 
            alt="Google logo" 
            className="google-logo" 
          />
          <span className="signin-text">Sign in with Google</span>
        </button>
      )}
    </div>
  );
}

export default GoogleSignIn;